import { render, staticRenderFns } from "./configureCharges.vue?vue&type=template&id=864d50dc&scoped=true&"
import script from "./configureCharges.vue?vue&type=script&setup=true&lang=js&"
export * from "./configureCharges.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./configureCharges.vue?vue&type=style&index=0&id=864d50dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864d50dc",
  null
  
)

export default component.exports